// extracted by mini-css-extract-plugin
export default {"badge":"SapBadge_badge__EVfMD"};